import React from 'react';
import './Footer.css';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="social-icons">
        <a href="https://www.instagram.com/lampo.digital/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/company/lampo-tecnologia/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
      </div>

      <nav className="footer-nav">
        <a href="#solucoes">Soluções</a>
        <a href="#clientes">Clientes</a>
        <a href="#monitoramento">Monitoramento Prudencial</a>
        <a href="#contato">Contato</a>
      </nav>

      <div className="footer-copy">
        © 2025 Lampo
      </div>
    </footer>
  );
}

export default Footer;